import {
    type FC
} from "react";
import {
    Pressable,
    View
} from "react-native";
import type ISidebarIconButtonProps from "./type";
import stylesheet, {
    getSidebarIconButtonColors,
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import StateLayer from "../../../stateLayer";

const SidebarIconButton: FC<ISidebarIconButtonProps> = ({
    icon: IconComponent,
    isActiveRow = false,
    isDisabled = false,
    isVisible = true,
    customTheme,
    onHoverOut,
    onPressOut,
    onHoverIn,
    onPressIn,
    placement,
    onFocus,
    onPress,
    onBlur,
    radius,
    style,
    title,
    ...props
}) => {
    const {
        shapeConfigs,
        iconSizes,
        borders,
        colors
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        interactionHandlers,
        isFocusVisible,
        isHovered,
        isPressed
    } = useInteractionState({
        isDisabled,
        onHoverOut,
        onPressOut,
        onHoverIn,
        onPressIn,
        onFocus,
        onBlur
    });

    const isExpanded = props["aria-expanded"] === true;

    const currentColors = getSidebarIconButtonColors({
        isEmphasized: isHovered || isPressed || isExpanded,
        isActiveRow,
        isDisabled,
        colors
    });

    const {
        container: containerDynamicStyle,
        surface: surfaceDynamicStyle
    } = useStyles({
        isFocusVisible,
        shapeConfigs,
        isDisabled,
        isVisible,
        placement,
        borders,
        colors,
        radius
    });

    return <Pressable
        {...props}
        {...interactionHandlers}
        aria-disabled={isDisabled}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
        disabled={isDisabled}
        aria-label={title}
        onPress={onPress}
        role="button"
    >
        <View
            style={[
                stylesheet.surface,
                surfaceDynamicStyle
            ]}
        >
            <StateLayer
                isPressed={!isDisabled && (isPressed || isExpanded)}
                isHovered={!isDisabled && isHovered}
                customTheme={customTheme}
                overlayColor="default"
                borderRadius={radius}
                borderWidth={0}
            />
            <IconComponent
                customColor={currentColors.iconColor}
                color={currentColors.iconColorKey}
                size={iconSizes.small}
            />
        </View>
    </Pressable>;
};
export default SidebarIconButton;
